/**
 * @internal
 * Internal reference for the render function
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "SLOT_RENDER_FUNCTION_SYMBOL", {
    enumerable: true,
    get: ()=>SLOT_RENDER_FUNCTION_SYMBOL
});
const SLOT_RENDER_FUNCTION_SYMBOL = /*#__PURE__*/ Symbol('fui.slotRenderFunction'); //# sourceMappingURL=constants.js.map

//# sourceMappingURL=constants.js.map